import { Component, HostBinding, input } from '@angular/core';


@Component({
    selector: 'exl-tag',
    templateUrl: './tag.component.html',
    styleUrls: ['./tag.component.scss'],
    host: { class: 'exl-tag', dir: 'auto' },
    imports: []
})
export class TagComponent {
    readonly label = input<string>(undefined);
    readonly url = input(undefined);
    @HostBinding('class.exl-tag') true;

    constructor() {}
}
